import clsx from 'clsx'
import type { ReactNode } from 'react'
import '../../styles/slp.css'

/**
 * SLP panel card — white body, bright-blue title bar with centered white
 * text, rounded corners, thin border (SessionLinkPRO look, rt UI v2 spec).
 */
export function Panel({
  title,
  children,
  className,
}: {
  title: string
  children: ReactNode
  className?: string
}) {
  return (
    <section
      data-testid={`slp-panel-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
      className={clsx(
        'overflow-hidden rounded-md border border-[var(--slp-border)] bg-[var(--slp-panel)] shadow-sm',
        className,
      )}
    >
      {/* v2.13: 26px title bar, white 12px/600 centered; 10px body padding,
          12px body text at 1.4 line-height — all fixed px, no scaling */}
      <header className="flex h-[26px] items-center justify-center bg-[var(--slp-blue)] px-3 text-[12px] font-semibold leading-none text-[var(--slp-blue-text)]">
        {title}
      </header>
      <div className="p-[10px] text-[12px] leading-[1.4] text-[var(--slp-text)]">{children}</div>
    </section>
  )
}
